module.exports = {"TXTWCL_Responsible_gaming":{"id":"TXTWCL_Responsible_gaming","defaultMessage":"Ответственная игра","track":"Responsible gaming"}}